/* unplugin-vue-components disabled */import script from "./TrialFundGuideHost.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialFundGuideHost.vue?vue&type=script&setup=true&lang=js"

import "./TrialFundGuideHost.vue?vue&type=style&index=0&id=b8cd053e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8cd053e"]])

export default __exports__